import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@clarix/auth-store';

/**
 * Gates the chrome-free setup wizard at /setup. Only the workspace OWNER (or a
 * platform admin) may run initial setup; everyone else is bounced to the
 * workspace root, where normal routing takes over.
 *
 * Backend authorization remains the source of truth — this is UX only, to keep
 * non-owners out of the wizard on direct URL entry. The shell runs on the
 * workspace origin, so an in-app <Navigate to="/"> is sufficient (no
 * cross-origin hop is needed — that concern is the admin remote's standalone
 * guard, which is separate).
 */
export function RequireWorkspaceOwner() {
  const role = useAuthStore((s) => s.user?.workspace_role);
  const allowed = role === 'OWNER';

  if (!allowed) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
